/**
 * Ce fichier permets d'afficher les geofences
 *
 * © Moustapha HENNAWI - Click and Take off - 2021
 */

/*-------------------------------------------------------------------------------------------*/
import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { map } from './Map';
import { geofenceToFeature } from './mapUtil';
import { selectGeofencesArray, selectSession } from '../createSelectorUtils';

/*-----------------------------*/

/*-------------------------------------------------------------------------------------------*/
export default function GeofenceMap() {
  const geofences = useSelector(selectGeofencesArray);

  const session = useSelector(selectSession);

  const elementGeo = useMemo(
    () => [
      { id: 'geofences_P', tag: '-P', flag: session.attributes.geofencesP },
      { id: 'geofences_A', tag: '-A', flag: session.attributes.geofencesA },
      { id: 'geofences_Vac', tag: '-Vac', flag: session.attributes.geofencesVac }
    ],
    [session.attributes.geofencesA, session.attributes.geofencesP, session.attributes.geofencesVac]
  );

  useEffect(() => {
    elementGeo.map((item) => {
      if (map.getSource(item.id) === undefined) {
        map.addSource(item.id, {
          type: 'geojson',
          data: {
            type: 'FeatureCollection',
            features: []
          }
        });
      }

      map.addLayer({
        source: item.id,
        id: `geofences-fill${item.tag}`,
        type: 'fill-extrusion',
        filter: ['all', ['==', '$type', 'Polygon']],
        layout: {
          visibility: item.flag ? 'visible' : 'none'
        },
        paint: {
          'fill-extrusion-color': { type: 'identity', property: 'color' },
          'fill-extrusion-opacity': 0.3,
          'fill-extrusion-height': { type: 'identity', property: 'height' },
          'fill-extrusion-base': { type: 'identity', property: 'base' }
        }
      });
      map.addLayer({
        source: item.id,
        id: `geofences-line${item.tag}`,
        type: 'line',
        layout: {
          visibility: item.flag ? 'visible' : 'none'
        },
        paint: {
          'line-color': ['get', 'color'],
          'line-width': ['get', 'width']
        }
      });
      map.addLayer({
        source: item.id,
        id: `geofences-title${item.tag}`,
        type: 'symbol',
        layout: {
          'text-field': '{name}',
          'text-size': 12,
          'text-font': ['Roboto Regular'],
          visibility: item.flag ? 'visible' : 'none'
        },
        paint: {
          'text-halo-color': 'white',
          'text-halo-width': 1
        }
      });

      return null;
    });

    return () => {
      elementGeo.map((item) => {
        if (map.getLayer(`geofences-fill${item.tag}`)) {
          map.removeLayer(`geofences-fill${item.tag}`);
        }
        if (map.getLayer(`geofences-line${item.tag}`)) {
          map.removeLayer(`geofences-line${item.tag}`);
        }
        if (map.getLayer(`geofences-title${item.tag}`)) {
          map.removeLayer(`geofences-title${item.tag}`);
        }
        return null;
      });
    };
  }, [elementGeo]);

  useEffect(() => {
    if (
      geofences.length === 0 ||
      elementGeo.map((item) => map.getSource(item.id) === undefined).filter((item) => item).length >
        0
    ) {
      return;
    }

    const geofencesA = geofences.filter((item) => item.description === 'A');
    const geofencesP = geofences.filter((item) => item.description === 'PROHIBITED');
    const geofencesVac = geofences.filter(
      (item) => item.description !== 'A' && item.description !== 'PROHIBITED'
    );

    elementGeo.map((item) => {
      switch (item.id) {
        case 'geofences_A':
          map.getSource(item.id).setData({
            type: 'FeatureCollection',
            features: Object.values(geofencesA).map((geofence) => geofenceToFeature(geofence))
          });
          break;
        case 'geofences_P':
          map.getSource(item.id).setData({
            type: 'FeatureCollection',
            features: Object.values(geofencesP).map((geofence) => geofenceToFeature(geofence))
          });
          break;
        case 'geofences_Vac':
          map.getSource(item.id).setData({
            type: 'FeatureCollection',
            features: Object.values(geofencesVac).map((geofence) => geofenceToFeature(geofence))
          });
          break;
        default:
          break;
      }
      return null;
    });
  }, [elementGeo, geofences]);

  return null;
}
